import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import Digit from './Digit';
import theme from '../../styles/theme';

const calculateDigits = value => {
  const result = String(Math.floor(value)).split('').map(digit => +digit);
  if (result.length === 1) {
    return [0, result[0]];
  }
  return result;
};

const Segment = ({
  animated, classes, className, caption, value,
}) => {
  const digits = calculateDigits(value);
  return (
    <div className={cn(className, classes.segment)}>
      <span className={classes.value}>
        {digits.map((digit, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Digit key={digits.length - i} animated={animated} value={digit} />
        ))}
      </span>
      <span className={classes.caption}>
        {caption}
      </span>
    </div>
  );
};

Segment.propTypes = {
  animated: PropTypes.bool,
  caption: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  value: PropTypes.number.isRequired,
};

Segment.defaultProps = {
  animated: true,
  className: undefined,
};

export default injectSheet({
  segment: {
    display: 'inline-block',
    textAlign: 'center',
  },
  value: {
    display: 'flex',
    marginBottom: 4,
  },
  caption: {
    fontFamily: theme.fonts.body,
    fontWeight: theme.fonts.bodyWeight,
    display: 'block',
    fontSize: 16,
    letterSpacing: 0.3,
    lineHeight: 1.5,
  },
})(Segment);
